import { render, staticRenderFns } from "./AdminTravelServiceItemEditView.vue?vue&type=template&id=6c219fb1&"
import script from "./AdminTravelServiceItemEditView.vue?vue&type=script&lang=js&"
export * from "./AdminTravelServiceItemEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c219fb1')) {
      api.createRecord('6c219fb1', component.options)
    } else {
      api.reload('6c219fb1', component.options)
    }
    module.hot.accept("./AdminTravelServiceItemEditView.vue?vue&type=template&id=6c219fb1&", function () {
      api.rerender('6c219fb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/travel-service/AdminTravelServiceItemEditView.vue"
export default component.exports